import { Component, OnInit, ViewChild, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { SfDataService } from '../../services/sf-data.service';
import { UserEdit } from '../../models/user-edit.model';
import { Subject } from 'rxjs';
import { AccountService } from '../../services/account.service';
import { Router } from '@angular/router';
import { Permission } from '../../models/permission.model';
import { ConfigurationService } from '../../services/configuration.service';


@Component({
    selector: 'app-sf-icd-campaignmaster',
    templateUrl: './sf-icd-campaignmaster.component.html',
    styleUrls: ['./sf-icd-campaignmaster.component.scss'],
    standalone: false
})
export class SfIcdCampaignmasterComponent implements OnInit {


  @ViewChild(DataTableDirective, { static: false })
  datatableElement: DataTableDirective;
  dtOptions: any = {};
  lstdata: any = [];

  public userEdit: UserEdit;
  @Input()
  isViewOnly: boolean;

  @Input()
  isGeneralEditor = false;



  constructor(private alertService: AlertService, private sfDataService: SfDataService, private accountService: AccountService, private router: Router, private configurations: ConfigurationService) { }


  ngOnInit() {

    if (!this.canViewCustomers) {
      this.router.navigate(['/']);

    }
    if (!this.isGeneralEditor) {

      this.dtOptions = {
        pagingType: 'full_numbers',
        pageLength: this.configurations.defaultPageSize,
        lengthMenu: [10, 25, 50, 100],
        processing: true,
        ajax: (dataTablesParameters: any, callback) => {
          this.sfDataService.getCMReports().subscribe(resp => {
            

            this.lstdata = resp;
            this.lstdata = this.getDistinctColumnValues(resp, 'status'); // Replace 'columnName' with your actual column name
            ////console.log(this.lstdata);

            callback({
              //recordsTotal: resp.recordsTotal,
              //recordsFiltered: resp.recordsFiltered,
              data: resp             // <-- see here
            });
            // this.alertService.showStickyMessage('Data loaded', '', MessageSeverity.info);
            $('.dt-buttons').addClass('pull-right');
          });
        },
        columns: [ 
           {
          title: 'Campaign No',
          data: 'name'
        }
          , {
          title: 'Campaign Name',
          data: 'campaignName'
        }

          , {
          title: 'Channel',
            data: 'channel'
        }
          , {
            title: 'Status',
            data: 'status'
        }
          , {
            title: 'LegacyCampaignInfo',
            data: 'legacyCampaignInfo'
        }
          , {
            title: 'SupplementalBackground',
            data: 'supplementalBackground'
          }
          , {
            title: 'BackgroundCheck',
            data: 'backgroundCheck'
          }
          , {
            title: 'DrugScreen',
            data: 'drugScreen'
          }
          , {
            title: 'Country',
            data: 'country'
          }

        ],
        // Declare the use of the extension in the dom parameter
        dom: 'lBfrtip',
        responsive: true,
        intiComplete: function (settings: any, json: any) {
          $('.dt-buttons').addClass('pull-right');
        },
        // Configure the buttons
        buttons: [
          //'columnsToggle',
          //'colvis',
          //'copy',
          //'print',
          { extend: 'excel', title: "CM", text: 'Export to Excel', className: 'btn btn-sm btn-success mb-2 pull-right' },
          //{
          //  text: 'Some button',
          //  key: '1',
          //  action: function (e, dt, node, config) {
          //    alert('Button activated');
          //  }
          //}
        ]
      };
    }
  }


  ngAfterViewInit(): void {

  }

  get canViewCustomers() {
    return true;// this.accountService.userHasPermission(Permission.viewUsersPermission); // eg. viewCustomersPermission
  }


  getDistinctColumnValues(data: any[], columnName: string): string[] {
    const columnValues = data.map(item => item[columnName]);
    return [...new Set(columnValues)];
  }

  filterTableByStatus(status: string) {
    // Get the DataTable instance using the DataTables jQuery selector
    const table = $('#tbldata').DataTable();

    // Update the search text in the "Request Status" column to filter by the clicked status
    if (status == null) {
      table.column(3).search('').draw();
    }
    else { table.column(3).search(status).draw(); }
    
  }



}
